module.exports = __webpack_public_path__ + "static/media/tab-tablet.dc986d81.png";